import angular from 'angular';
import '../../shared.module';
import template from './payment-confirmation.component.html';
import './payment-confirmation.component.scss';
import { pendingChargeId } from '../order.helper';
import { CHARGE_STATUS_LABELS } from '../order-status.constant';

class PaymentConfirmationController {
  constructor(OrderApiService, NotificationService, ConfirmService, SessionService) {
    this.OrderApiService = OrderApiService;
    this.NotificationService = NotificationService;
    this.ConfirmService = ConfirmService;
    this.canSend = SessionService.hasPermission('order.update');
    this.checking = false;
    this.sending = false;
  }

  get paid() {
    return Boolean(this.order) && this.order.pagamento === 'paid';
  }

  get chargeId() {
    return this.paymentId || (this.order ? pendingChargeId(this.order) : null);
  }

  get conversation() {
    return this.conversationId || (this.order && this.order.conversaId) || null;
  }

  check() {
    if (this.checking || !this.chargeId) return null;
    this.checking = true;
    return this.OrderApiService.refreshCharge(this.chargeId)
      .then((charge) => {
        if (charge.status !== 'paid') {
          this.NotificationService.info(
            `Pagamento ainda não identificado: cobrança ${CHARGE_STATUS_LABELS[charge.status] || charge.status}.`
          );
          return null;
        }
        return this.OrderApiService.get(this.order.id).then((order) => {
          this.NotificationService.success(`Pagamento do pedido #${order.numero} confirmado.`);
          if (this.onPaid) this.onPaid({ order });
        });
      })
      .catch((failure) => this.NotificationService.error(failure.message))
      .finally(() => {
        this.checking = false;
      });
  }

  sendConfirmation() {
    if (this.sending || !this.conversation) return null;
    return this.ConfirmService.whenConfirmed(
      {
        title: 'Enviar confirmação ao cliente',
        message: `Enviar a mensagem de pagamento confirmado do pedido #${this.order.numero} com os vouchers na conversa do cliente?`,
        confirmLabel: 'Enviar'
      },
      () => {
        this.sending = true;
        return this.OrderApiService.sendConfirmation(this.conversation, this.order.id)
          .then((result) => {
            this.order = { ...this.order, confirmacaoEnviada: true };
            this.NotificationService.success(
              `Confirmação enviada com ${result.vouchers} voucher(s).`
            );
            if (this.onSent) this.onSent();
          })
          .catch((failure) => this.NotificationService.error(failure.message))
          .finally(() => {
            this.sending = false;
          });
      }
    );
  }
}

PaymentConfirmationController.$inject = [
  'OrderApiService',
  'NotificationService',
  'ConfirmService',
  'SessionService'
];

angular.module('app.shared').component('cpPaymentConfirmation', {
  bindings: {
    order: '<',
    paymentId: '<',
    conversationId: '<',
    onPaid: '&',
    onSent: '&'
  },
  controller: PaymentConfirmationController,
  controllerAs: 'vm',
  template
});
